import * as React from "react";
const SvgFiRrCameraMovie = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-camera-movie_svg__a)">
      <path
        fill="#062147"
        d="M22.575 10.152a2.3 2.3 0 0 0-2.517.5l-.438.438a5.03 5.03 0 0 0-2.189-2.458 4.99 4.99 0 0 0 1.568-3.633c0-2.757-2.243-5-5-5a5 5 0 0 0-4 2.003 5 5 0 0 0-4-2.003A5.007 5.007 0 0 0 1 5c0 1.429.603 2.721 1.568 3.633A5 5 0 0 0 0 13v6c0 2.757 2.243 5 5 5h10a5.01 5.01 0 0 0 4.621-3.09l.438.438a2.3 2.3 0 0 0 2.516.501A2.3 2.3 0 0 0 24 19.716v-7.429c0-.938-.56-1.775-1.425-2.133zM14 2c1.654 0 3 1.346 3 3s-1.346 3-3 3-3-1.346-3-3 1.346-3 3-3M6 2c1.654 0 3 1.346 3 3S7.654 8 6 8 3 6.654 3 5s1.346-3 3-3m12 17c0 1.654-1.346 3-3 3H5c-1.654 0-3-1.346-3-3v-6c0-1.654 1.346-3 3-3h10c1.654 0 3 1.346 3 3zm4 .714c0 .171-.104.25-.191.286a.29.29 0 0 1-.337-.067L20 18.461v-4.922l1.472-1.472a.29.29 0 0 1 .337-.067.29.29 0 0 1 .191.286z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-camera-movie_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCameraMovie;
